import { render } from "./SafetyVideos.vue?vue&type=template&id=eef57fb6"
import script from "./SafetyVideos.vue?vue&type=script&lang=js"
export * from "./SafetyVideos.vue?vue&type=script&lang=js"

import "./SafetyVideos.vue?vue&type=style&index=0&id=eef57fb6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__